<template>
  <div grid grid-cols="1 md:3" justify-items-center gap-40px md:gap-20px my-100px>
    <div>
      <div relative md:bg-transparent max-w-320px py-20px>
        <div>
          <NuxtImg :src="`${'/img/linework.svg'}`" alt="" absolute top="20%" left="83% xl:90%" w="xl:50% 40%" z="0" invisible md:visible dark:invert />
        </div>

        <div :data-test="getCypressId('how-it-works-create-account')" z-10 flex flex-col items-center justify-center gap-25px md:gap-54px>
          <div p-40px fubex-shadow-lg rounded-full w-160px h-160px flex items-center justify-center dark="border-2 border-dashed">
            <UnoIcon i-fubex-user-badge h-78px w-78px text-primary-500 dark:text-primary-300 />
            <div
              z-10
              absolute top="md:-1% 1%" left="md:20%   15%"
              rounded-full bg-primary-50 text-center w-40px h-40px p-9px
            >
              1
            </div>
          </div>
          <div text-neutral-900 flex gap-16px text-center flex-col items-center justify-center>
            <h2 heading6 font-600>
              {{ $t('components.howItWorks.createAccount') }}
            </h2>
            <p paragraph-md>
              {{ $t('components.howItWorks.createAccountDescription') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div relative md:bg-transparent max-w-320px py-20px>
        <div>
          <NuxtImg :src="`${'/img/linework.svg'}`" alt="" absolute top="25%" left="82% xl:90%" w="xl:50% 40%" z="0" invisible md:visible rotate-180 dark:invert />
        </div>

        <div :data-test="getCypressId('how-it-works-verification')" flex flex-col items-center justify-center gap-25px md:gap-54px>
          <div p-40px border-2 border-dashed rounded-full w-160px h-160px flex items-center justify-center>
            <UnoIcon i-fubex-shield h-78px w-78px text-primary-400 dark:text-primary-200 />
            <div
              z-10
              absolute top="md:-1% 1%" left="md:20%  15%"
              rounded-full bg-neutral-50 text-center w-40px h-40px p-9px
            >
              2
            </div>
          </div>
          <div text-neutral-900 flex gap-16px text-center flex-col items-center justify-center>
            <h2 heading6 font-600>
              {{ $t('components.howItWorks.verification') }}
            </h2>
            <h3 paragraph-md>
              {{ $t('components.howItWorks.verificationDescription') }}
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div relative md:bg-transparent max-w-320px py-20px>
        <div :data-test="getCypressId('how-it-works-buy-and-sell')" z-10 flex flex-col items-center justify-center gap-25px md:gap-54px>
          <div p-40px border-2 border-dashed rounded-full w-160px h-160px flex items-center justify-center>
            <UnoIcon i-fubex-order h-78px w-78px text-primary-400 dark:text-primary-200 />
            <div
              z-10
              absolute top="md:-1% 1%" left="md:20%  15%"
              rounded-full bg-neutral-50 text-center w-40px h-40px p-9px
            >
              3
            </div>
          </div>
          <div text-neutral-900 flex gap-16px text-center flex-col items-center justify-center>
            <h2 heading6 font-600>
              {{ $t('components.howItWorks.buyAndSell') }}
            </h2>
            <h3 paragraph-md>
              {{ $t('components.howItWorks.buyAndSellDescription') }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
